export default __webpack_public_path__ + "static/media/chart-day.35b2cf19.png";